export default "__VITE_ASSET__B3y78AbL__"